import { render, staticRenderFns } from "./transformer.vue?vue&type=template&id=94b303a8&scoped=true"
import script from "./transformer.vue?vue&type=script&lang=js"
export * from "./transformer.vue?vue&type=script&lang=js"
import style0 from "@/utils/style/table.css?vue&type=style&index=0&id=94b303a8&prod&scoped=true&lang=css&external"
import style1 from "./transformer.vue?vue&type=style&index=1&id=94b303a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b303a8",
  null
  
)

export default component.exports